import React, { Component } from "react";
import "./RxAssistantInfo.css";
import { Checkbox, CheckboxProps, Form, Icon, InputOnChangeData, Message } from "semantic-ui-react";
import ActionButton from "../ActionButton/ActionButton";
import { IRxAssistantOperator } from "../../lib/rxMode/IRxAssistantOperator";
import { RxAssistantOperatorModes } from "../../lib/rxMode/IRxAssistantOperatorModes";
import RxBagVerificationModal from "../BoxReview/components/RxBagVerificationModal/RxBagVerificationModal";

class RxAssistantInfo extends Component<{
    assistantOperator: IRxAssistantOperator,
    cancelAssistantOperator: (assistingOperatorID: number) => void,
    setAssistantOperator: (payload: IRxAssistantOperator) => void,
    closeDialogCallback: ()=> void,
}, {}> {

    state = {
        input: "",
        pack_enabled: false,
        pick_enabled: false,
    }
    _onInput(e: InputOnChangeData) {
        if (e.value !== "Enter") {
            this.setState({
                input: e.value.trim(),
            });
        } else this.handeOperatorInputData();
    }

    handleChange = (checkBoxChecked: CheckboxProps) => {
        this.setState((prevState: any) => {
            return {
                ...prevState,
                pack_enabled: (checkBoxChecked.label == "PACK") ? !prevState.pack_enabled : prevState.pack_enabled,
                pick_enabled: (checkBoxChecked.label == "PLOCK") ? !prevState.pick_enabled : prevState.pick_enabled
            }
        })
    }

    handeOperatorInputData = () => {
        if (!this.state.input || isNaN(this.state.input!! as unknown as number)) return
        var mode: RxAssistantOperatorModes = RxAssistantOperatorModes.PACK_PLOCKKONTROLL;
        if (!(this.state.pack_enabled && this.state.pick_enabled)) {
            if (this.state.pack_enabled) mode = RxAssistantOperatorModes.PACK;
            else if (this.state.pick_enabled) mode = RxAssistantOperatorModes.PLOCKKONTROLL;
            else return
        }
        this.props.closeDialogCallback();
        this.props.setAssistantOperator(({
            assistingOperatorID: Number.parseInt(this.state.input!!.valueOf().toString()),
            assistingOperatorName: "",
            assistingMode: mode
        }))
    }

    render() {
        return (
            <Message
                className="messageBox"
                size={"large"}
                info>
                {(this.props.assistantOperator != undefined && this.props.assistantOperator.assistingOperatorID > -1) ? (
                    <div>
                        <div className="cartInfoTag partial">ASSISTENT</div>
                        <div className="flexRow fullWidth">
                            <div className="AssistantInfocard" style={{ flexGrow: 1 }}>
                                <div>
                                    <Checkbox
                                        className="checkboxDisabled"
                                        label="PACK"
                                        checked={(this.state.pack_enabled || 
                                            this.props.assistantOperator.assistingMode == RxAssistantOperatorModes.PACK_PLOCKKONTROLL ||
                                            this.props.assistantOperator.assistingMode == RxAssistantOperatorModes.PACK)}
                                        onChange={(_, data) => { this.handleChange(data) }} /> &nbsp;
                                    <Checkbox
                                        className="checkboxDisabled"
                                        label="PLOCK"
                                        checked={this.state.pick_enabled || 
                                            this.props.assistantOperator.assistingMode == RxAssistantOperatorModes.PACK_PLOCKKONTROLL ||
                                            this.props.assistantOperator.assistingMode == RxAssistantOperatorModes.PLOCKKONTROLL}
                                        onChange={(_, data) => { this.handleChange(data) }} /> &nbsp;
                                </div>
                                <span>{this.props.assistantOperator.assistingOperatorName}</span>
                            </div>

                            <ActionButton
                                className="endAssistantBtn"
                                onClick={() => this.props.cancelAssistantOperator(this.props.assistantOperator.assistingOperatorID)}
                                show={true}
                                disabled="disabled"
                                buttonText="AVSLUTA"
                            ></ActionButton>
                        </div>
                    </div>) : (
                    <div>
                        <div className="flexRow fullWidth">
                            <div className="cartInfoTag fullWidth" style={{ flexWrap: 'wrap' }}>
                                <Checkbox
                                    label="PACK"
                                    checked={this.state.pack_enabled}
                                    onChange={(_, data) => { this.handleChange(data) }} /> &nbsp;
                                <Checkbox
                                    label="PLOCK"
                                    checked={this.state.pick_enabled}
                                    onChange={(_, data) => { this.handleChange(data) }} />
                                <Form.Input
                                    id="OperatorNumberInput"
                                    fluid
                                    icon="user"
                                    size="small"
                                    placeholder="Operatörsnummer"
                                    autoFocus
                                    autoComplete="off"
                                    loading={false}
                                    onChange={(_, data) => { this._onInput(data) }}
                                    onKeyPress={(e: any) => { if (e.key === "Enter") this._onInput({ value: "Enter" }) }}
                                    value={this.state.input}
                                />
                            </div>
                           
                            <ActionButton
                                onClick={this.handeOperatorInputData}
                                show={true}
                                color="teal"
                                buttonText="ANGE ASSISTENT"
                            ></ActionButton>
                             <Icon size="large" style={{ float: "right" }} name="window close" onClick={() => { this.props.closeDialogCallback(); }} ></Icon>
                        </div>
                    </div>
                )}
            </Message>)
    }
}

export default RxAssistantInfo;
